<template>
  <div>
    <navbar-component :user_regions="null"></navbar-component>
    <div class="container">
      <button class="btn btn-success m-3" data-toggle="modal" data-target="#createRegionModal">
        建立區域
      </button>
      <router-link to="/home">
        <button class="btn btn-info m-3 text-white" data-toggle="modal" data-target="#createRegionModal">
          返回前台
        </button>
      </router-link>
      <create-region></create-region>
      <div :class="{ 'row': !isMobile }">
        <div :class="{ 'col-6': !isMobile }" v-for="region, index in regions" :key="index">
          <region-component :regionData="region" @update-region="updateRegion"></region-component>
        </div>
      </div>
      <footer-component></footer-component>
    </div>
  </div>
</template>

<script>
import CreateRegion from './backend/CreateRegion.vue';
import RegionComponent from './backend/RegionComponent.vue';
import NavbarComponent from './layouts/NavbarComponent.vue';
import FooterComponent from './layouts/FooterComponent.vue';
import { axiosMixins } from './mixins/axiosErrorMessage';

export default {
  components: { NavbarComponent, CreateRegion, RegionComponent, FooterComponent },
  mixins: [axiosMixins],
  data() {
    return {
      regions: '',
      windowSize: window.innerWidth,
      isMobile: false,
    }
  },
  mounted() {
    this.updateRegion();
    this.checkDevice()
  },
  methods: {
    listRegions() {
      axios.get(base_url + "/api/regions/")
        .then((response) => {
          this.regions = response.data.map((region) => {
            if (
              !region.is_deleted_in_this_region
              // && region.role_in_this_region < 3
              // && region.bx_alias === 'test001'
              && !!region.bx_meters
            ) {
              return {
                'id': region.id,
                'name': region.name,
                'bx_alias': region.bx_alias,
                'meters': region.bx_meters
              };
            } else {
              return null;
            }
          }).filter((el) => el);
        })
        .catch((error) => this.axiosMessage(error));
    },
    checkDevice() {
      if (this.windowSize < 1200) {
        this.isMobile = true;
      }
    },
    updateRegion() {
      this.listRegions();
    }
  },
}
</script>

<style></style>
